import { FC } from "react";

export const LeftClick: FC = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
  >
    <path
      stroke="#F6F7FD"
      strokeLinecap="round"
      strokeWidth={2.1}
      d="M23.333 11.666v4.667A9.333 9.333 0 0 1 14 25.666a9.333 9.333 0 0 1-9.334-9.333V10.5a8.167 8.167 0 0 1 8.167-8.167H14a9.333 9.333 0 0 1 9.333 9.333Z"
    />
    <path
      stroke="#F6F7FD"
      strokeLinecap="round"
      strokeWidth={2.1}
      d="M14 2.333V9.8a.7.7 0 0 1-.7.7H4.667"
    />
  </svg>
  );
};